import React, { useState, useEffect }  from 'react';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FaRegCircleUser } from "react-icons/fa6";


import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate, Link } from "react-router";

import Dropdown from 'react-bootstrap/Dropdown';

import { MdLocationPin } from "react-icons/md";

import  Logo  from "../../logo.svg";

import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import * as actionsPropertyType from '../../store/propertyType/actions';

const Header = ({getPropertyTypes, propertyTypeWithAttributes, loggedIn}) => {
    
    const navigate = useNavigate();
    const [propertyTypes, setPropertyTypes] = useState();
    const [ commercialProperties, setCommercialProperties ] = useState();
    const [ residentialProperties, setResidentialProperties ] = useState();
    useEffect(() => {
		loadData();
	},[]);

    // console.log('loggedIn', loggedIn)

    useEffect(() => {
        if(propertyTypeWithAttributes){
		    setPropertyTypes(propertyTypeWithAttributes);
        }
        if(propertyTypeWithAttributes && propertyTypeWithAttributes.residential_properties && propertyTypeWithAttributes.residential_properties.length>0){
            setResidentialProperties(propertyTypeWithAttributes.residential_properties);
        }
        if(propertyTypeWithAttributes && propertyTypeWithAttributes.commercial_properties && propertyTypeWithAttributes.commercial_properties.length>0){
            setCommercialProperties(propertyTypeWithAttributes.commercial_properties);
        }
	},[propertyTypeWithAttributes]);

    const loadData = async() => {
        
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }
   
    return (
        <header className='MainHeader sticky-top'>
             <Navbar expand="xl" className="bg-body-tertiary">
                <Container fluid>
                    <Navbar.Brand href="/">
                        <img src={Logo} alt="Big Sauda" title="Big Sauda" />
                    </Navbar.Brand>
                    <Navbar.Text><MdLocationPin />Jaipur</Navbar.Text>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto ms-auto" navbarScroll>
                            <NavDropdown title="Buy" id="basic-nav-dropdown">
                                <Row className='dropDownNav'>
                                <Col>
                                    <h5>Commercial</h5>
                                    {
                                        commercialProperties && commercialProperties.length > 0 ?
                                            commercialProperties.map((commercialProperty, commercialPropertyIndex)=>{
                                                return <NavDropdown.Item href={`/commercial/properties-to-buy/${commercialProperty.property_type_id}`} key={`buy-commercial${commercialPropertyIndex}`}>{commercialProperty.title}</NavDropdown.Item>
                                            })
                                        : ''
                                    }
                                </Col>
                                <Col>
                                    <h5>Residential</h5>
                                    {
                                        residentialProperties && residentialProperties.length > 0 ?
                                            residentialProperties.map((residentialProperty, residentialPropertyIndex)=>{
                                                return <NavDropdown.Item href={`/residential/properties-to-buy/${residentialProperty.property_type_id}`} key={`buy-residential${residentialPropertyIndex}`}>{residentialProperty.title}</NavDropdown.Item>
                                            })
                                        : ''
                                    }
                                </Col>
                                </Row>
                            </NavDropdown>
                            <NavDropdown title="Rent" id="basic-nav-dropdown2">
                                <Row className='dropDownNav'>
                                    <Col>
                                        <h5>Commercial</h5>
                                    {
                                        commercialProperties && commercialProperties.length > 0 ?
                                            commercialProperties.map((commercialProperty, commercialPropertyIndex)=>{
                                                return <NavDropdown.Item href={`/commercial/properties-for-rent/${commercialProperty.property_type_id}`} key={`rent-commercial${commercialPropertyIndex}`}>{commercialProperty.title}</NavDropdown.Item>
                                            })
                                        : ''
                                    }
                                    </Col>
                                    <Col>
                                    <h5>Rsidential</h5>
                                    {
                                        residentialProperties && residentialProperties.length > 0 ?
                                            residentialProperties.map((residentialProperty, residentialPropertyIndex)=>{
                                                return <NavDropdown.Item href={`/residential/properties-for-rent/${residentialProperty.property_type_id}`} key={`rent-residential${residentialPropertyIndex}`}>{residentialProperty.title}</NavDropdown.Item>
                                            })
                                        : ''
                                    }
                                    </Col>
                                </Row>
                            </NavDropdown>
                            {/* <Nav.Link href="#home">Lease Property</Nav.Link> */}
                            {/* <Nav.Link href="#link">Advisors</Nav.Link> */}
                            {/* <Nav.Link href="#home">Joint Ventures</Nav.Link> */}
                            <Nav.Link href="/post-ad/step1">Add Your Property</Nav.Link>
                            <Nav.Link href={`/agents`}>Agent</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <div className='d-flex align-items-center flex-grow-1 flex-xl-grow-0 mt-3 mt-xl-0 justify-content-between mNav'>
                        
                        {
                            loggedIn === false ? 
                                <Nav.Link className='me-3' href="/login"><FaRegCircleUser /> Login/Sign Up</Nav.Link> 
                            : 
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                                        <FaRegCircleUser /> Hi, Ankit
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="/update-profile">Setting</Dropdown.Item>
                                        <Dropdown.Item href="/logout">Sign Out</Dropdown.Item>
                                        {/* <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>  */}
                                    </Dropdown.Menu>
                                </Dropdown>
                        }
                        
                        <Navbar.Text>
                            <Button variant='primary' onClick={()=>navigate(`/post-ad/step1`)}>Post Free Listing</Button>
                        </Navbar.Text>
                    </div>
                </Container>
                </Navbar>
        </header>
    )
}


function mapStateToProps(state) {
    return {
        propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes,
        loggedIn: state.customer.loggedIn
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getPropertyTypes: () => dispatch(actionsPropertyType.getPropertyTypes())
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(Header);